module.exports = __webpack_public_path__ + "static/img/H28.a57cc4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/q_and_a/H28.png
// module id = QWdv
// module chunks = 0